import { ReactNode } from 'react';

export type Logo = {
  source: string;
  width: number;
  height: number;
};

export type LogoVariants = {
  small: Logo;
  large: Logo;
  largeInverse?: Logo;
};

export type FeatureValue = boolean | string | number | null;

export type FeatureFlags = { [key: string]: boolean | string | number | null };

/**
 * conditions to restrict navigation items such as menus and menuitems
 */
export type Conditions = {
  // user session required or forbidden?
  auth?: boolean;
  // experiment variation required?
  experiment?: { [name: string]: string };
  // feature required?
  feature?: { [name: string]: FeatureValue };
  // display for screen width small, medium, large only? Or !medium, !large?
  mediaQuery?:
    | 'small'
    | 'medium'
    | 'large'
    | '!small'
    | '!medium'
    | '!large'
    | string;
};

export type MenuItem = {
  badge?: 'messages' | 'notifications';
  condition?: Conditions;
  crawlable?: boolean;
  icon?: string | ReactNode;
  label: string;
  name: string;
  testId?: string;
  url?: string | Record<string, string>;
  type?: 'action' | 'masked' | 'link' | 'route' | 'divider';
};

export type Menu = {
  condition?: Conditions;
  icon?: string | ReactNode;
  items?: MenuItem[];
  label: string;
  name: string;
  testId?: string;
};

export type NavigationItem = Menu | MenuItem;
export type Navigation = NavigationItem[];

export type Experiment = {
  isActive: boolean;
  key: string;
  ticketCode?: string;
  variation?: string;
};

export enum Theme {
  DEFAULT = 'default',
  BRAND = 'brand',
  TAKEOVER = 'takeover',
  GHOST = 'ghost'
}

export type User = {
  avatar?: string;
  username: string;
};
